import { useLocalStorage } from 'src/hooks/local-storage';

type UsePdfOpacityProps = {
  sheetId: string | null;
  pageNumber: number;
};

export function usePdfOpacity({ sheetId, pageNumber }: UsePdfOpacityProps) {
  const [opacityStore, setOpacityStore] = useLocalStorage<
    Record<string, Record<number, number>>
  >('sheet-pdf-opacity-v2', {});

  const storageKey = sheetId ?? 'default';
  const opacity = (opacityStore[storageKey]?.[pageNumber] ?? 80) as number;
  const setOpacity = (value: number) => {
    setOpacityStore((prev) => {
      const sheetMap = prev[storageKey] ?? {};
      return {
        ...prev,
        [storageKey]: {
          ...sheetMap,
          [pageNumber]: value,
        },
      };
    });
  };

  return {
    opacity,
    setOpacity,
  };
}
